import {Box, Flex} from "@chakra-ui/react";
import React from "react";
import {NavLink} from "react-router-dom"


export default function HeaderButtonGroupThemes() {

    return (
        <Flex mx='30px' gap='15px'>
            {/*Styles is in the App.css file since hover was being problematic to apply*/}
            <NavLink to="/home/themes" className={isActive => "nav-link" + (isActive ? " active" : " unselected")}>
                <Box h='48px' p='12px 16px'>
                    Themes
                </Box>
            </NavLink>
            <NavLink to="/home/products" className={isActive => "nav-link" + (isActive ? " active" : " unselected")}>
                <Box borderRadius='10px' h='48px' p='12px 16px'> Products
                </Box>
            </NavLink>
            {/*<NavLink to="/home/analyze-aspects"*/}
            {/*         className={isActive => "nav-link" + (isActive ? " active" : " unselected")}>*/}
            {/*    <Box borderRadius='15px' h='48px' p='12px 16px'>*/}
            {/*        Reviews*/}
            {/*    </Box>*/}
            {/*</NavLink>*/}

            <NavLink to="/home/search" className={isActive => "nav-link" + (isActive ? " active" : " unselected")}>
                <Box borderRadius='10px' h='48px' p='12px 16px'>
                    Search
                </Box>
            </NavLink>
        </Flex>
    )
}